export default __webpack_public_path__ + "media/images/elephant_ui_working_sub.png.old-63f5105875942649336c7cc7ad8f3c64.png";